import { TranslatorService } from './../../../core/services/translator/translator.service';
import { ConfirmBoxColor } from '@app/custom-shared/components/alerts/confirm-box/confirm-box.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import {
  Fundo,
  Usuario,
  Grupo,
  GrupoPost,
  FundoId,
  UsuarioId,
} from './editar-grupo-de-investimento.model';
import { EditarGrupoDeInvestimentoService } from './editar-grupo-de-investimento.service';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
import { CaceisApiErrors } from '@app/core/services/exception/caceis-exceptions/caceis-api-errors/caceis-api-errors';
import { MatSort } from '@angular/material/sort';
import { FeatureService } from '@app/core/services/feature/feature.service';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-editar-grupo-de-investimento',
  templateUrl: './editar-grupo-de-investimento.component.html',
  styleUrls: ['./editar-grupo-de-investimento.component.scss'],
})
export class EditarGrupoDeInvestimentoComponent implements OnInit {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  displayedColumnsUsuarios: string[] = [
    'select',
    'name',
    'login',
    'permissionGroup',
    'status',
  ];
  dataSourceUsuarios: MatTableDataSource<Usuario>;
  selectionUsuarios = new SelectionModel<Usuario>(true, []);
  displayedColumnsFundos: string[] = ['select', 'code', 'name'];
  dataSourceFundos: MatTableDataSource<Fundo>;
  selectionFundos = new SelectionModel<Fundo>(true, []);
  selectedIndex: number = 0;
  fundsComplete = [];
  usersComplete = [];
  investmentGroupName: string;
  usersSorted: boolean = false;
  fundsSorted: boolean = false;
  group: Grupo;
  groupId: string;
  @ViewChild('sortUsers', { static: false }) sortUsers: MatSort;
  @ViewChild('sortFunds', { static: false }) sortFunds: MatSort;
  @ViewChild('paginator') paginator: MatPaginator;

  constructor(
    private _editarGrupoDeInvestimentoService: EditarGrupoDeInvestimentoService,
    private customAuthenticationService: CustomAuthenticationService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EditarGrupoDeInvestimentoComponent>,
    private dialogBoxService: DialogBoxService,
    private featureService: FeatureService,
    private translatorService: TranslatorService
  ) { }

  async ngOnInit(): Promise<any> {

    this.group = await this.getFounds(this.groupId);
    this.instantiateFunds();
    this.instantiateUsers();
    this.investmentGroupName = this.group.name;


    this.dataSourceFundos.filterPredicate = (data, filter) => {
      return (
        data.code.toLocaleLowerCase().includes(filter.toLocaleLowerCase()) ||
        data.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase())
      );
    };
    this.dataSourceUsuarios.filterPredicate = (data, filter) => {
      return data.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
    };

    this.dataSourceFundos.data.forEach(row => {
      if (row.checked === true) this.selectionFundos.select(row);
    });
    this.dataSourceUsuarios.data.forEach(row => {
      if (row.checked === true) this.selectionUsuarios.select(row);
    });
  }


  instantiateFunds() {

    if (!this.group && !this.group.funds) return;

    this.group.funds.forEach(item => {
      if (!item.name) item.name = '';
      if (!item.code) item.code = '';
      if (!item.idInvestmentFund) item.idInvestmentFund = '';
      if (item.checked == null) item.checked = false;
    });
    this.group.funds = [
      ...this.group.funds.naturalSort(["code"]).filter(item => item.checked), // Seleciona os itens marcados
      ...this.group.funds.naturalSort(["code"]).filter(item => !item.checked) // Seleciona os itens desmarcados
    ];

    this.dataSourceFundos = new MatTableDataSource(this.group.funds);
    this.dataSourceFundos = new MatTableDataSource(this.dataSourceFundos.data)
    this.dataSourceFundos.data.sort((a, b) =>
      (a.checked === b.checked) ? 0 : a.checked ? -1 : 1
    );
    this.dataSourceFundos.sortingDataAccessor = (data, sortHeaderId) => data[sortHeaderId].naturalNormalize();
    this.dataSourceFundos.sort = this.sortFunds;
    this.dataSourceFundos.paginator = this.paginator;
  }

  instantiateUsers() {

    if (!this.group && !this.group.users) return;

    this.group.users = this.group.users.filter(el => el.status !== 'Inativo');

    this.group.users.forEach(item => {
      if (!item.name) item.name = '';
      if (!item.email) item.email = '';
      if (!item.id) item.id = '';
      if (item.status == null) item.status = '';
      if (item.checked == null) item.checked = false;
    });
    this.group.users = [
      ...this.group.users.naturalSort(["name"]).filter(item => item.checked), // Seleciona os itens marcados
      ...this.group.users.naturalSort(["name"]).filter(item => !item.checked) // Seleciona os itens desmarcados
    ];

    this.dataSourceUsuarios = new MatTableDataSource(this.group.users);
    this.dataSourceUsuarios = new MatTableDataSource(this.dataSourceUsuarios.data)
    this.dataSourceUsuarios.data.sort((a, b) =>
      (a.checked === b.checked) ? 0 : a.checked ? -1 : 1
    );
    this.dataSourceUsuarios.sortingDataAccessor = (data, sortHeaderId) => data[sortHeaderId].naturalNormalize();
    this.dataSourceUsuarios.sort = this.sortUsers;
  }



  async getFounds(id: string): Promise<any> {
    try {
      const payload = { id: id };
      const result = await this._editarGrupoDeInvestimentoService.getFounds(payload);
      return result;
    } catch (e) {
      console.log(e);
    }
  }

  isAllSelectedUsuarios() {
    const numSelected = this.selectionUsuarios.selected.length;
    const numRows =
      this.dataSourceUsuarios != null ? this.dataSourceUsuarios.data.length : 0;
    return numSelected === numRows;
  }

  masterToggleUsuarios() {
    this.isAllSelectedUsuarios()
      ? this.selectionUsuarios.clear()
      : this.dataSourceUsuarios.data.forEach(row =>
        this.selectionUsuarios.select(row),
      );
  }

  checkboxLabel(row?: Usuario): string {
    if (!row) {
      return `${this.isAllSelectedUsuarios() ? 'select' : 'deselect'} all`;
    }
    return `${this.selectionUsuarios.isSelected(row) ? 'deselect' : 'select'
      } row ${row.email + 1}`;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceUsuarios.filter = filterValue.trim().toLowerCase();

    if (filterValue.length > 0 && filterValue.length % 2 == 0) {
      this.usersComplete = this.dataSourceUsuarios.filteredData;
    } else if (filterValue.length == 0) {
      this.usersComplete = [];
    }
  }

  isAllSelectedFundos() {
    const numSelected = this.selectionFundos.selected.length;
    const numRows =
      this.dataSourceFundos != null ? this.dataSourceFundos.data.length : 0;
    return numSelected === numRows;
  }

  masterToggleFundos() {
    this.isAllSelectedFundos()
      ? this.selectionFundos.clear()
      : this.dataSourceFundos.data.forEach(row =>
        this.selectionFundos.select(row),
      );
  }

  checkboxLabelFundos(row?: Fundo): string {
    if (!row) {
      return `${this.isAllSelectedFundos() ? 'select' : 'deselect'} all`;
    }
    return `${this.selectionFundos.isSelected(row) ? 'deselect' : 'select'
      } row ${row.code + 1}`;
  }

  applyFilterFundos(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceFundos.filter = filterValue.trim().toLowerCase();

    if (filterValue.length > 0 && filterValue.length % 2 == 0) {
      this.fundsComplete = this.dataSourceFundos.filteredData;
    } else if (filterValue.length == 0) {
      this.fundsComplete = [];
    }
  }

  sortData(column: string) {
    this.usersSorted = !this.usersSorted;

    this.dataSourceUsuarios.data.sort((a, b) => {

      switch (column) {
        case 'name': return this.compare(a.name.naturalNormalize(), b.name.naturalNormalize(), this.usersSorted);
        case 'login': return this.compare(a.email.naturalNormalize(), b.email.naturalNormalize(), this.usersSorted);
        case 'permissionGroup': return this.compare(a.permissionGroup.naturalNormalize(), b.permissionGroup.naturalNormalize(), this.usersSorted);
        case 'status': return this.compare(a.status.naturalNormalize(), b.status.naturalNormalize(), this.usersSorted);
        default: return 0;
      }
    })
  }

  compare(a, b, isAsc) {
    if (a === null) {
      a = '';
    }
    if (b === null) {
      b = '';
    }
    return (a.toLowerCase().localeCompare(b.toLowerCase()) ? 1 : -1) * (isAsc ? 1 : -1);
  }

  saveGroup() {
    let title, msg, back, save: string
    title = this.translatorService.translateConfirmBox('changesToInvGrp')
    msg = this.translatorService.translateConfirmBox('changesImpact')
    back = this.translatorService.translateConfirmBox('backStep')
    save = this.translatorService.translateConfirmBox('saveGroup')

    this.dialogBoxService.confirmBox({
      lblTitle: title,
      lblSubtitle: msg,
      color: ConfirmBoxColor.info,
      lblCancelButton: back,
      lblConfirmButton: save,
      onConfirm: () => {
        const investimentGroup = new GrupoPost();
        investimentGroup.name = this.investmentGroupName;
        investimentGroup.id = this.group.id;
        investimentGroup.funds = this.selectionFundos.selected.map(a => {
          const fundo = new FundoId();
          //fundo.id = a.idInvestmentFund;
          fundo.code = a.code;
          // fundo.name = a.name;
          return fundo;
        });
        investimentGroup.users = this.selectionUsuarios.selected.map(user => {
          const usuario = new UsuarioId();
          usuario.id = user.id;
          return usuario;
        });
        let msgInvGrp, msgSaved: string
        msgInvGrp = this.translatorService.translateConfirmBox('investmentsGroup')
        msgSaved = this.translatorService.translateConfirmBox('wasSaved')

        this._editarGrupoDeInvestimentoService
          .postInvestmentGroup(investimentGroup)
          .then(
            () => {
              this.dialogBoxService.snackbarUtil.showSuccess(
                msgInvGrp + ` "${this.investmentGroupName}" ` + msgSaved,
              );
              this.dialogRef.close();
            },
            err => {
              if (err.status === 422) {
                if (err.apierror.customErrorCode == 'SC0011') {
                  CaceisApiErrors.SC0011.showError();
                } else {
                  // CaceisApiErrors.GENERIC_ERROR.showError();
                }

              }
            },
          );
      },
      onCancel: () => {
        this.dialogRef.close();
      },
    });
  }

  selectedIndexChange(val: number) {
    this.selectedIndex = val;
  }


  doFechar() {
    let titlepopup, subtitlepopup, cancelpopup, okpopup: string
    this.featureService.translatorService
      .getMessage('titleConfirm')
      .subscribe(val => {
        titlepopup = val
      })
    this.featureService.translatorService
      .getMessage('subtitleConfirm')
      .subscribe(val => {
        subtitlepopup = val
      })
    this.featureService.translatorService
      .getMessage('cancelConfirm')
      .subscribe(val => {
        cancelpopup = val
      })
    this.featureService.translatorService
      .getMessage('okConfirm')
      .subscribe(val => {
        okpopup = val
      })

    this.dialogBoxService.confirmBox({
      lblTitle: titlepopup,
      lblSubtitle: subtitlepopup,
      lblCancelButton: cancelpopup,
      lblConfirmButton: okpopup,
      color: ' red',
      onConfirm: () => {
        this.dialogRef.close();
      },
    });
  }
}
